/* eslint-disable */

import React from 'react';
import { string, number, object, func } from 'prop-types';
import { FormatF, formatPercent } from 'Shared/helpers.js';
import './HorizontalBar.scss';

const HorizontalBar = ({ title, value, totalValue, color, onClickBar }) => (
  <div className="priority" key={title}>
    <div className="name">
      <span className="priority-name mr-2">
        <strong>{`${title}`}</strong>
      </span>
      <span className="font-weight-light">
        <a href="#" onClick={onClickBar}>
          {value} open
        </a>
        <span>{` (${formatPercent(value / totalValue)})`}</span>
      </span>
    </div>
    <div className="line" style={{ width: `${(value / totalValue) * 100}%`, backgroundColor: color }} />
  </div>
);

HorizontalBar.propTypes = {
  title: string.isRequired,
  value: number.isRequired,
  totalValue: number.isRequired,
  onClickBar: func.isRequired,
};

export default HorizontalBar;
